module.exports = __webpack_public_path__ + "img/Apoptosis-CRC_CRLM.54a502fe.png";